var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDirection = function SvgDirection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.166 11.5h1.667V9h2.916v2.083l2.917-2.917-2.917-2.917v2.084H6a.8.8 0 0 0-.594.24.8.8 0 0 0-.239.593zm3.333 5.833q-.312 0-.615-.125a1.7 1.7 0 0 1-.551-.375L.666 10.166a1.7 1.7 0 0 1-.375-.552 1.6 1.6 0 0 1-.125-.615q0-.312.125-.615.125-.302.375-.551l6.667-6.667q.249-.25.552-.375T8.5.666q.313 0 .615.125.303.124.552.375l6.667 6.667q.249.249.375.552.125.303.125.614 0 .313-.125.615a1.7 1.7 0 0 1-.375.552l-6.667 6.667q-.25.249-.552.375a1.6 1.6 0 0 1-.615.125"
  })));
};
export default SvgDirection;